import React, { useEffect, useRef, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
  Modal,
  ModalBody,
  Label,
} from "reactstrap";
import Utils from "../../Utility";
import { post, get, put, upload } from "../../../helpers/api_helper";
import DeleteModal from "./DeleteModal";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import UserProfile from "../../../components/UserProfile";
import { AvField, AvForm } from "availity-reactstrap-validation";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import Resizer from "react-image-file-resizer";
import moment from "moment/moment";

const Table = (props) => {
  const { user, setLoading } = props;
  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);
  const [currentData, setCurrentData] = useState(null);
  const [isAddForm, setIsAddForm] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [currentAudio, setCurrentAudio] = useState(null);
  const [userModal, setUserModal] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(undefined);
  const [selectedLang, setSelectedLang] = useState([]);
  const [file, setFile] = useState(null);
  const [audio, setAudio] = useState(null);
  const imageInput = useRef();
  const cropper = useRef();

  useEffect(() => {
    if (user) {
      getData();
    }
  }, [user]);

  const getData = () => {
    get("/category", { token: user?.token })
      .then((json) => {
        // console.log('response from get project list', json);
        if (json?.statusCode == 200) {
          setData(json?.data);
        }
      })
      .catch((error) => {
        console.log("error while getting project list", error);
      });
  };

  useEffect(() => {
    setColumns([
      // {
      //   name: "S No.",
      //   cell: (row, index) => (
      //     <>
      //       <Draggable key={row._id} draggableId={row._id} index={index}>
      //         {(provided, snapshot) => (
      //           <div
      //             ref={provided.innerRef}
      //             {...provided.draggableProps}
      //             {...provided.dragHandleProps}
      //           >
      //             <i
      //               className="mdi mdi-menu"
      //               style={{ fontSize: 20, color: Utils.themeColor }}
      //             ></i>
      //           </div>
      //         )}
      //       </Draggable>
      //     </>
      //   ),
      //   maxWidth: "50px",
      // },


      {
        name: "Title",
        cell: (row) => (
          <>
            <span title={row?.title}>{row?.title}</span>
          </>
        ),
        selector: (row) => row._id,
      },

      {
        cell: (row) => (
          <>
            <Button
              onClick={() => handleUpdateStatus(row)}
              title={row?.isActive ? "Inactive" : "Active"}
              style={{
                backgroundColor: !row.isActive ? "red" : "green",
                marginRight: 10,
                padding: 6,
                paddingLeft: 8,
                paddingRight: 8,
                border: "none",
              }}
            >
              <span className="text-white" style={{}}>
                {!row?.isActive ? "Inactive" : "Active"}
              </span>
            </Button>
          </>
        ),
        name: "Status",
        ignoreRowClick: true,
        maxWidth: "120px",
      },

      {
        cell: (row) => (
          <>

            <Button
              onClick={() => handleUpdateProj(row)}
              title={"Edit"}
              style={{
                // backgroundColor: Utils.themeColor,
                marginRight: 10,
                padding: 5,
                paddingLeft: 8,
                paddingRight: 8,
                border: "none",

              }}
            >
              <span className="mdi mdi-pencil" style={{ fontSize: 20 }}></span>
            </Button>
            <Button
              onClick={() => handleDeleteProj(row)}
              title={"Delete"}
              style={{
                // backgroundColor: Utils.themeColor,
                backgroundColor: "blue",
                marginRight: 10,
                padding: 5,
                paddingLeft: 8,
                paddingRight: 8,
                border: "none",
              }}
            >
              <span className="mdi mdi-delete" style={{ fontSize: 20 }}></span>
            </Button>
          </>
        ),
        name: "Action",
        ignoreRowClick: true,
        maxWidth: "120px",
        // allowOverflow: true,
        // button: true,
      },
    ]);
  }, [data]);

  useEffect(() => {
    if (!isAddForm) {
      setCurrentData(null);
      setFile(null);
      setAudio(null);
      setCurrentAudio(null);
      setSelectedLang([]);
    }
  }, [isAddForm]);

  const handlePaid = (row) => {
    setCurrentData({ ...row, actionType: "Paid" });
    setDeleteModal(true);
  };

  const handleUpdateProj = (proj) => {
    // console.log('updating proj', proj);
    setCurrentData(proj);
    setFile(proj?.image);
    setAudio(proj?.audio);
    if (proj?.alterLang?.length) {
      proj?.alterLang?.forEach((lang) => {
        user?.languages?.forEach((allLang) => {
          if (allLang?.code == lang?.code) lang.lang = allLang?.title;
        });
      });
      setSelectedLang(proj?.alterLang);
    }
    setIsAddForm(true);
  };

  const handleUpdateStatus = (item) => {
    // console.log('updating proj', item);
    setCurrentData({ ...item, actionType: "Status" });
    setDeleteModal(true);
  };

  const handleUpdateLive = (row) => {
    setCurrentData({ ...row, actionType: "Live" });
    setDeleteModal(true);
  };

  const handleDeleteProj = (proj) => {
    // console.log('updating proj', proj);
    setCurrentData({ ...proj, actionType: "Delete" });
    setDeleteModal(true);
  };

  const onDelete = () => {
    console.log("deleted", currentData);
    let body = {
      catId: currentData?._id,
      token: user?.token,
    };
    let url = "/category";
    if (currentData?.actionType == "Status") {
      body = { ...body, isActive: !currentData?.isActive };
    } else if (currentData?.actionType == "Live") {
      body = { ...body, isLive: !currentData?.isLive };
    } else if (currentData?.actionType == "Paid") {
      body = { ...body, isPaid: !currentData?.isPaid };
    } else {
      body = { ...body, isDeleted: true };
    }
    put(url, body)
      .then((json) => {
        console.log("response from on click action", json);
        if (json.statusCode == 200) {
          toast.success(json?.message);
          getData();
          setDeleteModal(false);
          props?.setCurrentData(null);
        } else {
          toast.error(json?.error);
        }
      })
      .catch((error) => {
        console.error("error while deleting user", error);
      });
  };

  const handleDragEnd = (result) => {
    console.log("dragging item", result);
    // Handle the drag-and-drop logic here
    if (!result.destination) return; // Item was dropped outside the list
    const items = [...data];
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    let ids = [],
      position = [];
    items.forEach((item, index) => {
      ids.push(item?._id);
      position.push(index);
    });
    let body = {
      ids,
      position,
      token: user?.token,
    };
    put("/podcast/position", body).then((res) => {
      // if (res?.statusCode == 200)
      setData(items);
    });
  };

  const onChangeFile = async (e) => {
    // console.log('on change file', e.target);
    setFile(URL.createObjectURL(e.target.files[0]));
    // setCropperModal(true);
  };

  const urltoFile = (url, filename, mimeType) => {
    return fetch(url)
      .then(function (res) {
        return res.arrayBuffer();
      })
      .then(function (buf) {
        return new File([buf], filename, { type: mimeType });
      });
  };

  const resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        1800,
        600,
        "webp",
        100,
        0,
        (uri) => {
          resolve(uri);
        },
        "file"
      );
    });

  const handleValidSubmit = async (e, v) => {
    console.log("values", v);
    let body = {
      ...v,
      catId: currentData?._id,
      token: user?.token,
    };
    setLoading(true);

    put("/category", body)
      .then((res) => {
        setLoading(false);
        if (res?.statusCode == 200) {
          toast.success(res?.message);
          getData();
          setIsAddForm(false);
        } else {
          toast.error(res?.error);
        }
      })
      .catch((err) => {
        toast.error(err);
        setLoading(false);
      });
  };

  const handleToggleAudio = (row, index) => {
    setCurrentAudio(row?.audio);
    console.log("playing", row, index);
    const audioElement = document.getElementById("audio");
    if (!audioElement) return;
    if (row?.isPlaying) {
      audioElement.pause();
      if (currentData) {
        setCurrentData({ ...currentData, isPlaying: false });
      } else {
        let dat = Object.assign([], data);
        dat[index].isPlaying = false;
        setData(dat);
      }
    } else {
      audioElement.pause();
      setTimeout(() => {
        audioElement.play();
        if (currentData) {
          setCurrentData({ ...currentData, isPlaying: true });
        } else {
          let dat = Object.assign([], data);
          dat.map((item, inde) => {
            if (inde == index) item.isPlaying = true;
            else item.isPlaying = false;
          });
          setData(dat);
        }
      }, 500);
    }
  };

  const handleSelectLang = (code, lang) => {
    let temp = Object.assign([], selectedLang);
    let already = temp.findIndex((x) => x.code == code);
    if (already == -1) {
      temp.push({ code: code, title: "", lang });
    } else {
      temp.splice(already, 1);
    }
    // console.log("temp", temp);
    setSelectedLang(temp);
  };

  const handleAlterTitle = (index, key, val) => {
    let temp = Object.assign([], selectedLang);
    temp[index][key] = val;
    setSelectedLang(temp);
  };

  const parseDate = (str) => {
    if (str) {
      let date = str?.split(":");
      let modify = date[0] + ":" + date[1];
      // console.log("date", str, date[0] + ":" + date[1]);
      return modify;
    } else return "";
  };

  // console.log('currentData', currentData)

  return (
    <React.Fragment>
      <div className="">
        <Row>
          <UserProfile
            userId={currentUserId}
            show={userModal}
            onCloseClick={() => setUserModal(false)}
            user={user}
          />
          <DeleteModal
            show={deleteModal}
            onDeleteClick={() => onDelete()}
            onCloseClick={() => setDeleteModal(false)}
            data={currentData}
          />
          <Modal isOpen={isAddForm} centered={true} style={{ maxWidth: 800 }}>
            <ModalBody className="py-3 px-5">
              {/* <h5 className="text-black font-size-20">
                {currentData ? `View Tender` : `View Tender List`}
              </h5> */}
              <div className="p-2">
                <AvForm
                  className="form-horizontal"
                  onValidSubmit={(e, v) => {
                    handleValidSubmit(e, v);
                  }}
                >
                  <Row>

                    <Col lg={12} md={12}>
                      <div className="mb-3">
                        <AvField
                          name="title"
                          label="Title *"
                          className="form-control"
                          placeholder="Enter sound title"
                          type="text"
                          required
                          value={currentData?.title}
                        />
                      </div>
                    </Col>
                  </Row>
                  {/* <Label>Alternative Languages</Label>
                  <Row>
                    <div className="lang-checks mb-3">
                      {user?.languages?.map((item) => (
                        <div className="check-group">
                          <label for={item?.title} class="container">
                            {item?.title}
                            <input
                              type="checkbox"
                              name={item?.title}
                              id={item?.title}
                              checked={
                                selectedLang.findIndex(
                                  (x) => x?.code == item?.code
                                ) != -1
                              }
                              onChange={(e) =>
                                handleSelectLang(item?.code, item?.title)
                              }
                            />
                            <span class="checkmark"></span>
                          </label>
                        </div>
                      ))}
                    </div>
                    {selectedLang?.map((item, index) => (
                      <Row>
                        <Col md={12}>
                          <div className="mb-3">
                            <AvField
                              name={"title" + item?.lang}
                              label={"Title in " + item?.lang}
                              className="form-control"
                              placeholder={"Enter title in " + item?.lang}
                              type="text"
                              onChange={(e) =>
                                handleAlterTitle(index, "title", e.target.value)
                              }
                              required
                              value={item?.title}
                            />
                          </div>
                        </Col>
                      </Row>
                    ))}
                  </Row> */}
                  <div className="mt-4">
                    <Row>
                      <Col md={6}>
                        <button
                          className="btn btn-primary w-100 waves-effect waves-light"
                          style={{
                            backgroundColor: Utils.themeColor,
                            border: "none",
                          }}
                          onClick={() => {
                            setIsAddForm(false);
                          }}
                          type="reset"
                        >
                          Cancel
                        </button>
                      </Col>
                      <Col md={6}>
                        <button
                          className="btn btn-primary w-100 waves-effect waves-light"
                          type="submit"
                          style={{
                            backgroundColor: Utils.themeColor,
                            border: "none",
                          }}
                        >
                          {currentData ? "Update" : "Add"}
                        </button>
                      </Col>
                    </Row>
                  </div>
                </AvForm>
              </div>
            </ModalBody>
          </Modal>
          <Col className="col-12">
            <Card>
              <CardBody>
                <div
                  className="d-flex"
                  style={{ marginLeft: "auto", marginBottom: 30 }}
                >
                  <div>
                    <CardTitle className="h4">{props.role} </CardTitle>

                    {/* <CardSubtitle className="mb-3">
                      <code> Anybody</code> can see the all{" "}
                      <code> Inquiry List</code> if status is <code>Active.</code>{" "}
                      Also those are not live will appear in{" "}
                      <code>Scheduled</code> list.
                    </CardSubtitle> */}
                  </div>
                  <div className="text-center" style={{ marginLeft: "auto" }}>
                    <input
                      type="text"
                      value={""}
                      onChange={(e) => handleFilter(e.target.value)}
                      placeholder="Search..."
                      style={{
                        marginTop: "2px",
                        padding: "5px 5px 5px 20px",
                        borderRadius: "15px",
                        border: "1px solid grey",
                      }}
                    />
                    <button
                      style={{
                        float: "right",
                        border: "none",
                        color: "#008000",
                        fontSize: "25px",
                        backgroundColor: "white",
                      }}
                    >
                      {" "}
                      <i
                        className="mdi mdi-magnify"
                        style={{ marginBottom: "20px" }}
                      ></i>
                    </button>
                    {/* <Button style={{ backgroundColor: Utils.themeColor, marginRight: 10 }} onClick={() => downloadZip()}>
                      Zip Images
                    </Button> */}
                    {/* <Button
                      style={{
                        backgroundColor: Utils.themeColor,
                        border: "none",
                      }}
                      onClick={() => setIsAddForm(true)}
                    >
                      Add
                    </Button> */}
                  </div>
                </div>

                <DataTable
                  columns={columns}
                  data={data}
                  pagination
                  // selectableRows
                  paginationPerPage={100}
                  paginationRowsPerPageOptions={[100, 200, 300, 400]}
                  conditionalRowStyles={[
                    {
                      when: (row) => row?.style,
                      style: (row) => ({ width: row?.style?.width }),
                    },
                  ]}
                  customStyles={{
                    headCells: {
                      style: {
                        color: "black",
                        fontWeight: "bold",
                        fontSize: 15,
                        width: 0,
                      },
                    },
                    cells: {
                      style: {
                        width: 0,
                      },
                    },
                  }}
                />

              </CardBody>
            </Card>
            <audio id="audio" src={currentAudio} />
          </Col>
          <audio id="audio" src={currentAudio} />
        </Row>
      </div>
    </React.Fragment>
  );
};

export default Table;
